import React from 'react';

const AccessDenied = () => {
   
    return (
      <div style={{textAlign:'center',paddingTop:'35vh'}}>
        <h1 className='title'>Access Denied!</h1>
        <p>
        You do not have correct access level, to access this page, please reach out to:
        </p>
        <p>Eltham Liu(dengpan.liu@se.com) for more info.</p>
      </div>
    );
};
export default AccessDenied;